import React from 'react';
import { connect } from 'react-redux';
import style from './index.scss';
import { Layout, List, Space } from 'antd';
import { fetchRunInstanceHistory } from '../../../../../redux/actions/trm/trmDashboard';
import { AlertsLevelComponent } from '../../../components/TableComponents';
import moment from 'moment';
import { dateTimeFormat } from '../../../../../util/GlobalConstant';
import { TRM_CONSTANTS } from '../../../../constants/trmConstants';
const { Content } = Layout;
/**
 * RunInstanceHistory Class
 */
class RunInstanceHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      runInstanceHistoryList: [],
      defaultCurrent: 1,
      pageSize: 20,
      isLoading: false
    };
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.fetchRunInstanceHistory({
      scenarioID: this.props.scenarioID,
      page: this.state.defaultCurrent - 1,
      pageSize: this.state.pageSize
    });
  }

  /**
   * getDerivedStateFromProps
   * @param nextProps
   * @returns {null|{trmTypologies: ([]|*[]|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data, error: null}|*)}}
   */
  static getDerivedStateFromProps(nextProps) {
    const { trmDashboard } = nextProps;

    if (trmDashboard && trmDashboard.runInstanceHistoryList) {
      return {
        runInstanceHistoryList: trmDashboard.runInstanceHistoryList
      };
    }
    return null;
  }

  onPaginationChange = (page, pageSize) => {
    this.setState({ defaultCurrent: page, pageSize });
    this.props.fetchTypologiesOfScenarioData({
      scenarioID: this.props.scenarioID,
      page: page - 1,
      pageSize
    });
  };

  render() {
    const { showRemoveOption = true } = this.props;
    const { runInstanceHistoryList, defaultCurrent, pageSize } = this.state;
    const { isLoading = true, data = null } = runInstanceHistoryList || {};
    let runInstanceHistoryArray = [];
    let runInstanceHistoryCount = 0;
    if (!isLoading && data) {
      runInstanceHistoryArray = data.instances;
      runInstanceHistoryCount = data?.instances?.length;
    }
    return (
      <Layout className="layout">
        <Content>
          <Space
            size={5}
            direction="vertical"
            style={{ width: '100%', backgroundColor: 'white' }}>
            <Content>
              <div className={style.instanceLabelContainer}>
                <div
                  style={{ maxWidth: 250 }}
                  className={style.instanceLabelContainer}>
                  <div
                    style={{ marginRight: 10 }}
                    className={style.instanceLabel}>
                    Run Instance Id:
                  </div>
                  <div className={style.instanceLabel}>
                    {data?.scenario?.id ? data.scenario.id : '-'}
                  </div>
                </div>
              </div>
              <div className={style.typologyListHeader}>
                <div>Date Range</div>
                <div>Alerts Count</div>
                <div>Alerts Level</div>
              </div>
              <List
                size="small"
                bordered
                loading={this.state.isLoading || isLoading}
                pagination={{
                  total: runInstanceHistoryCount,
                  defaultCurrent: defaultCurrent,
                  onChange: this.onPaginationChange,
                  pageSize
                }}
                dataSource={runInstanceHistoryArray}
                renderItem={(item, index) => {
                  const {
                    id,
                    executionConfiguration,
                    totalAlert = '-',
                    highAlert = 0,
                    lowAlert = 0,
                    goodAlert = 0
                  } = item || {};
                  const executionConfigurationParsed = JSON.parse(
                    executionConfiguration
                  );
                  const { training, prediction } = executionConfigurationParsed;
                  const { dateRange: trainingDateRange } = training || {};
                  const { dateRange: predictionDateRange } = prediction || {};

                  return (
                    <List.Item
                      style={{
                        boxShadow:
                          'inset 0px -1px 1px #D0D7E3, inset 1px 0px 1px #D0D7E3, inset -1px 0px 1px #D9D9D9',
                        backgroundColor: 'white'
                      }}>
                      <div className={style.typologiesListItems}>
                        <div
                          style={{ display: 'flex', flexDirection: 'column' }}>
                          <div>
                            Training :-{' '}
                            {`${moment
                              .utc(trainingDateRange?.from, [dateTimeFormat])
                              .format('DD-MMM-YYYY')} - ${moment
                              .utc(trainingDateRange?.to, [dateTimeFormat])
                              .format('DD-MMM-YYYY')}`}
                          </div>
                          <div>
                            Prediction :-{' '}
                            {`${moment
                              .utc(predictionDateRange?.from, [dateTimeFormat])
                              .format('DD-MMM-YYYY')} - ${moment
                              .utc(predictionDateRange?.to, [dateTimeFormat])
                              .format('DD-MMM-YYYY')}`}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignSelf: 'center' }}>
                          {totalAlert}
                        </div>
                        <div>
                          <AlertsLevelComponent
                            highCount={highAlert}
                            goodCount={goodAlert}
                            lowCount={lowAlert}
                          />
                        </div>
                      </div>
                    </List.Item>
                  );
                }}
              />
            </Content>
          </Space>
        </Content>
      </Layout>
    );
  }
}

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{typologyListingDashboard: trmDashboard}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchRunInstanceHistory: (payload) => {
      dispatch(fetchRunInstanceHistory(payload));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RunInstanceHistory);
